import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';
import { fromEvent as observableFromEvent } from 'rxjs';
import { share } from 'rxjs/operators';

export const WINDOW_RESIZE = new InjectionToken<Observable<Event>>('Resize event observer', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);
    if (!defaultView) {
      throw new Error('Window is not available');
    }
    return observableFromEvent(defaultView, 'resize').pipe(share());
  },
});
